(function () {
  if (customElements.get('samp-bundle-builder')) return;

  class SampBundleBuilder extends HTMLElement {
    connectedCallback() {
      this.cfg = {
        counterNone: this.getAttribute('data-counter-none') || 'none chosen',
        counterProgress: this.getAttribute('data-counter-progress') || '[n] of [total] chosen',
        counterAll: this.getAttribute('data-counter-all') || 'all six',
        pickSingle: this.getAttribute('data-pick-single') || 'Pick Your Scent To Continue',
        pickOneMore: this.getAttribute('data-pick-one-more') || 'Pick 1 More Scent',
        pickMore: this.getAttribute('data-pick-more') || 'Pick [count] More Scents',
      };
      // Discount code silently applied before add-to-cart on discounted tiers.
      this.discountCode = this.getAttribute('data-discount-code') || 'SCENT-SET';
      // The 6-oil tier ships the Scented Drops SET, so it needs its own BXGY;
      // the 3-oil tier still uses the buy-one-oil-get-one-free code.
      this.discountCode6 = this.getAttribute('data-discount-code-6') || 'SCENT-AMP-DROPS';

      this.panels = {
        1: this.querySelector('[data-samp-panel="1"]'),
        2: this.querySelector('[data-samp-panel="2"]'),
      };
      this.back = this.querySelector('[data-samp-back]');
      this.counterEl = this.querySelector('[data-samp-counter]');
      this.scentList = this.querySelector('[data-samp-scents]');
      this.scents = Array.from(this.querySelectorAll('[data-samp-scent]'));
      this.atc = this.querySelector('[data-samp-atc]');
      this.incompleteEl = this.querySelector('[data-samp-incomplete]');
      this.errorEl = this.querySelector('[data-samp-error]');
      this.continueBtn = this.querySelector('[data-samp-continue]');

      this.addingText = (this.querySelector('.samp-buybox__atc-label--adding') || {}).textContent || 'Adding...';
      this.addedText = (this.querySelector('.samp-buybox__atc-label--added') || {}).textContent || 'Added To Cart';

      this.querySelectorAll('.samp-tier').forEach((card) => {
        const tag = card.querySelector('.samp-tier__tag');
        const name = card.querySelector('.samp-option__name');
        if (tag && name) name.appendChild(tag);
      });

      const atc6 = this.querySelector('.samp-buybox__atc-label--default [data-samp-tier-show="6"]');
      const cont6 = this.continueBtn ? this.continueBtn.querySelector('[data-samp-tier-show="6"]') : null;
      if (atc6 && cont6) cont6.innerHTML = atc6.innerHTML;

      this.querySelectorAll('.samp-tier .samp-option__radio').forEach((r) => {
        r.addEventListener('change', () => {
          if (r.checked) this.setTier(Number(r.value));
        });
      });

      if (this.continueBtn) {
        this.continueBtn.addEventListener('click', () => {
          if (this.tier === 6) {
            this.quickAddAll();
          } else {
            this.goToStep(2);
          }
        });
      }
      if (this.back) {
        this.back.addEventListener('click', (e) => {
          e.preventDefault();
          this.goToStep(1);
        });
      }

      this.scents.forEach((row) => {
        const radio = row.querySelector('.samp-scent__radio');
        if (radio) {
          radio.addEventListener('change', () => this.onRadioPick(row));
        }
        row.addEventListener('click', (e) => {
          if (this.scentList.dataset.mode !== 'radio') return;
          if (row.dataset.available !== 'true') return;
          if (e.target === radio) return;
          radio.checked = true;
          this.onRadioPick(row);
        });
        const minus = row.querySelector('[data-samp-minus]');
        const plus = row.querySelector('[data-samp-plus]');
        if (minus) minus.addEventListener('click', () => this.bump(row, -1));
        if (plus) plus.addEventListener('click', () => this.bump(row, 1));
      });

      if (this.atc) this.atc.addEventListener('click', () => this.addToCart());
    }

    get tier() { return Number(this.dataset.tier); }

    setTier(tier) {
      const prev = this.tier;
      this.dataset.tier = String(tier);
      if (tier !== prev) this.resetSelection();
      this.querySelectorAll('[data-samp-tier-price]').forEach((el) => {
        el.hidden = Number(el.dataset.sampTierPrice) !== tier;
      });
      this.querySelectorAll('[data-samp-tier-show]').forEach((el) => {
        el.hidden = Number(el.dataset.sampTierShow) !== tier;
      });
      this.clearError();
    }

    goToStep(step) {
      this.dataset.step = String(step);
      this.panels[1].hidden = step !== 1;
      this.panels[2].hidden = step !== 2;
      if (this.back) this.back.hidden = step !== 2;
      this.clearError();
      this.resetAtcVisual();
      if (step === 2) {
        const tier = this.tier;
        // Image-card layout uses steppers for every tier (capped at the tier count).
        this.scentList.dataset.mode = tier === 1 && this.scentList.dataset.layout !== 'cards' ? 'radio' : 'stepper';
        this.refresh();
      }
    }

    resetSelection() {
      this.scents.forEach((row) => {
        row.dataset.qty = '0';
        row.classList.remove('is-picked');
        const q = row.querySelector('[data-samp-qty]');
        if (q) q.textContent = '0';
        const radio = row.querySelector('.samp-scent__radio');
        if (radio) radio.checked = false;
      });
    }

    onRadioPick(row) {
      this.scents.forEach((r) => {
        r.dataset.qty = r === row ? '1' : '0';
        r.classList.toggle('is-picked', r === row);
      });
      this.refresh();
    }

    bump(row, delta) {
      if (row.dataset.available !== 'true') return;
      const tier = this.tier;
      const qty = Number(row.dataset.qty);
      const total = this.total();
      if (delta > 0 && total >= tier) return;
      const next = Math.max(0, qty + delta);
      row.dataset.qty = String(next);
      row.classList.toggle('is-picked', next > 0);
      const q = row.querySelector('[data-samp-qty]');
      if (q) q.textContent = String(next);
      this.refresh();
    }

    total() {
      if (this.tier === 6) return 6;
      return this.scents.reduce((sum, r) => sum + Number(r.dataset.qty), 0);
    }

    complete() {
      if (this.tier === 6) return true;
      return this.total() === this.tier;
    }

    refresh() {
      const tier = this.tier;
      const total = this.total();
      const done = this.complete();

      this.scents.forEach((row) => {
        const minus = row.querySelector('[data-samp-minus]');
        const plus = row.querySelector('[data-samp-plus]');
        const qty = Number(row.dataset.qty);
        if (minus) minus.disabled = qty === 0;
        if (plus) plus.disabled = row.dataset.available !== 'true' || (tier !== 6 && total >= tier);
      });

      if (this.counterEl) {
        this.counterEl.classList.remove('is-progress', 'is-complete');
        if (total === 0) {
          this.counterEl.textContent = this.cfg.counterNone;
        } else {
          this.counterEl.textContent = this.cfg.counterProgress.replace('[n]', total).replace('[total]', tier);
          this.counterEl.classList.add(done ? 'is-complete' : 'is-progress');
        }
      }

      if (this.atc) {
        const remaining = tier - total;
        this.atc.classList.toggle('is-incomplete', !done);
        if (!done && this.incompleteEl) {
          this.incompleteEl.textContent =
            tier === 1
              ? this.cfg.pickSingle
              : remaining === 1
                ? this.cfg.pickOneMore
                : this.cfg.pickMore.replace('[count]', remaining);
        }
      }
    }

    resetAtcVisual() {
      if (!this.atc) return;
      clearTimeout(this.addedTimer);
      this.atc.classList.remove('is-adding', 'is-added');
    }

    clearError() {
      if (this.errorEl) {
        this.errorEl.hidden = true;
        this.errorEl.textContent = '';
      }
    }

    buildItems() {
      const items = [{ id: Number(this.atc.dataset.ampVariant), quantity: 1 }];
      if (this.tier === 6) {
        // The 6-oil tier ships as a single Scented Drops set, not six separate oils.
        const drops = Number(this.atc.dataset.dropsVariant);
        if (drops) {
          if (this.atc.dataset.dropsAvailable === 'false') return null;
          items.push({ id: drops, quantity: 1 });
        } else {
          for (const row of this.scents) {
            if (row.dataset.available !== 'true') return null;
            items.push({ id: Number(row.dataset.variant), quantity: 1 });
          }
        }
      } else {
        this.scents.forEach((row) => {
          const qty = Number(row.dataset.qty);
          if (qty > 0) items.push({ id: Number(row.dataset.variant), quantity: qty });
        });
      }
      return items;
    }

    async applyDiscount() {
      const code = this.tier === 6 ? (this.discountCode6 || this.discountCode) : this.discountCode;
      if (this.tier <= 1 || !code) return;
      try {
        await fetch('/discount/' + encodeURIComponent(code), { redirect: 'follow' });
      } catch (e) {
        /* non-fatal: checkout can still enter the code manually */
      }
    }

    async postItems(items) {
      const res = await fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.description || data.message || 'Could not add to cart');
      }
    }

    async quickAddAll() {
      const btn = this.continueBtn;
      if (!btn || btn.classList.contains('is-adding')) return;
      const items = this.buildItems();
      if (!items) {
        if (this.errorEl) {
          this.errorEl.textContent = 'One of the six scents is currently unavailable.';
          this.errorEl.hidden = false;
        }
        return;
      }
      const span = btn.querySelector('[data-samp-tier-show="6"]');
      const orig = span ? span.innerHTML : '';
      clearTimeout(this.quickTimer);
      btn.classList.add('is-adding');
      if (span) span.textContent = this.addingText;
      this.clearError();
      try {
        await this.applyDiscount();
        await this.postItems(items);
        btn.classList.remove('is-adding');
        btn.classList.add('is-added');
        if (span) span.textContent = this.addedText;
        this.quickTimer = setTimeout(() => {
          btn.classList.remove('is-added');
          if (span) span.innerHTML = orig;
        }, 3000);
        this.refreshCartCount();
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
      } catch (err) {
        btn.classList.remove('is-adding');
        if (span) span.innerHTML = orig;
        if (this.errorEl) {
          this.errorEl.textContent = err.message;
          this.errorEl.hidden = false;
        }
      }
    }

    async addToCart() {
      if (!this.atc || this.atc.disabled) return;
      if (!this.complete()) return;
      if (this.atc.classList.contains('is-adding')) return;

      const items = this.buildItems();
      if (!items) {
        if (this.errorEl) {
          this.errorEl.textContent = 'One of the six scents is currently unavailable.';
          this.errorEl.hidden = false;
        }
        return;
      }

      this.resetAtcVisual();
      this.atc.classList.add('is-adding');
      this.clearError();

      try {
        await this.applyDiscount();
        await this.postItems(items);
        this.atc.classList.remove('is-adding');
        this.atc.classList.add('is-added');
        this.addedTimer = setTimeout(() => this.atc.classList.remove('is-added'), 3000);
        this.refreshCartCount();
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
      } catch (err) {
        this.atc.classList.remove('is-adding');
        if (this.errorEl) {
          this.errorEl.textContent = err.message;
          this.errorEl.hidden = false;
        }
      }
    }

    async refreshCartCount() {
      try {
        const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        const cart = await res.json();
        document.querySelectorAll('.cart-count-bubble span[aria-hidden], [data-cart-count], .cart-count').forEach((el) => {
          el.textContent = cart.item_count;
        });
      } catch (e) {
        /* non-fatal */
      }
    }
  }

  customElements.define('samp-bundle-builder', SampBundleBuilder);
})();
